<script>
  import { Tabs, TabsItem, Breadcrumb, BreadcrumbItem, Icon, Loader, Page } from "@gl/design-system"
  import { AppsRepository } from "../../repositories/index"
  import { Route, Router, navigate } from "svelte-routing"
  import { Layout } from "../../components/index"
  import { onMount, getContext } from "svelte"
  import { _ } from "../../stores/index"
  import AppAssignments from "./AppAssignments.svelte"
  import AppPolicies from "./AppPolicies.svelte"
  const { isAuthorized } = getContext("isAuthorized")

  export let id

  let app = {}
  let loading = true

  let selectedTab = "contracts"

  const setSelectedTabFromPathname = () => {
    const path = decodeURIComponent(window.location.pathname)
    if (path.includes("policies")) {
      selectedTab = "policies"
    } else {
      selectedTab = "contracts"
    }
  }

  async function fetchApp() {
    try {
      loading = true

      app = await AppsRepository.getApplication(id)
    } finally {
      loading = false
    }
  }

  onMount(() => {
    fetchApp()
    setSelectedTabFromPathname()
  })
</script>

<Layout selected="globalApps" fillHeight>
  {#if !loading}
    <Page>
      <Breadcrumb slot="breadcrumb">
        <BreadcrumbItem
          on:click={() => navigate("/access-manager/admin/apps")}
          on:keypress={(e) => {
            if (e.key === "Enter") navigate("/access-manager/admin/apps")
          }}
        >
          {$_("common.apps")}
        </BreadcrumbItem>
        <BreadcrumbItem current>
          {app.data.name}
        </BreadcrumbItem>
      </Breadcrumb>

      <h3 slot="header" class="gl-title level-3">
        {$_("common.app")}: {app.data.name}
      </h3>

      <Tabs slot="tabs">
        <TabsItem
          selected={selectedTab === "contracts"}
          on:click={() => {
            selectedTab = "contracts";
            navigate(`/access-manager/admin/apps/${id}/contracts`);
          }}
        >
          {$_("common.contracts")}
        </TabsItem>

        {#if $isAuthorized("policy_read")}
          <TabsItem
            selected={selectedTab === "policies"}
            on:click={() => {
              selectedTab = "policies";
              navigate(`/access-manager/admin/apps/${id}/policies`);
            }}
          >
            {$_("common.policies")}
          </TabsItem>
        {/if}
      </Tabs>

      <div class="tab-content">
        <Router>
          <Route path="/contracts">
            <AppAssignments {id} />
          </Route>
          <Route path="/policies">
            <AppPolicies {app} {id} />
          </Route>
        </Router>
      </div>
    </Page>
  {:else}
    <Loader />
  {/if}
</Layout>
